import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import {
  Container,
  Row,
  Col,
  Table,
  Card,
  CardBody,
} from "reactstrap"
import { SuccessOk } from "configs/statusCode"
import CardItem from "./CardItem"
import Paginator from "components/Common/Paginator/Paginator"
import SellerService from "services/Admin/SellerService"
import FilterModal from "./FilterModal"
import FilterIcon from "assets/images/filter.png"

const Seller = (props) => {
  const [loading, setLoading] = useState(false)
  const sellerService = new SellerService()
  const [active, setActive] = useState("all");
  const [searchWord, setSearchWord] = useState("")
  const [filterModal, setFilterModal] = useState(false)
  const [location, setLocation] = useState("")
  const [country, setCountry] = useState("")
  const [area, setArea] = useState([])
  const [list, setList] = useState([])
  const [filtersParams, setFilterParams] = useState(null)
  const [filterData, setFilterData] = useState({
    area_ids:[],
    country_ids: ''
  })
  const [shouldGetData, setShouldGetData] = useState(false)
  const [exportUrl, setExportUrl] = useState("")
  const [pageOptions, setPageOptions] = useState({
    sizePerPage: 10,
    totalSize: 1,
  });

  const OnSearchChange = (e) => {
    const search = e.target.value
    setSearchWord(search)
  }

  const exportFileHandler = () => {
    setLoading(true)
    const params = {
      seller: 1,
      export: 1
    }
    if (active != 'all') params['status'] = active === "active" ? 1 : 0
    if (searchWord.trim().length) params['keyword'] = searchWord.trim()
    if (location) params["location"] = location


    sellerService.getList(params).then(response => {
      setLoading(false)
      // const url = window.URL.createObjectURL(new Blob([response.data]));
      // const link = document.createElement('a');
      // link.href = url;
      // link.setAttribute('download', `${Date.now()}.xlsx`);
      // document.body.appendChild(link);
      // link.click();
    })
  }


  useEffect(() => {
    // debounce solution to reduce request data from api
    const timeoutId = setTimeout(() => {
      const params = {
        seller: 1
      }
      if (active != 'all') params['status'] = active === "active" ? 1 : 0
      if (searchWord.trim().length) params['keyword'] = searchWord.trim()
      // if (filterData?.country_ids?.value) params["country"] = filterData?.country_ids.value
      if (filterData?.area_ids.length) params["location"] = filterData?.area_ids?.map(item=> item.value).join()

      setFilterParams({ ...params })
    }, 1000)

    return () => clearTimeout(timeoutId)
  }, [active, filterData, searchWord])


  useEffect(() => {
    const url = sellerService.getExportUrl(active, location, searchWord)
    setExportUrl(url)
  }, [active, filterData, searchWord])

  return (
    <React.Fragment>
      <div className='page-content'>
        <MetaTags>
          <title>Seller</title>
        </MetaTags>
        <Container fluid>
          <Row className="mb-1">
            <Col md={6}>
              <h4>Manage Sellers</h4>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <div className="input-group mb-3">
                <input type="text" className="form-control" value={searchWord} onChange={(e) => OnSearchChange(e)} placeholder="Search by seller name, email, I.D" />
              </div>
            </Col>
            <Col md={6}>
              <div className="d-md-flex justify-content-md-end mb-2">
                <button
                  className="btn btnUpload btnHeight btnHeight px-lg-4 me-2"
                  onClick={() => window.open(exportUrl)}
                >
                  Export Excel Sheet
                </button>
               </div>
            </Col>
          </Row>
          <Row className="mb-4" >
            <Col md={6} sm={8} className="mb-3">
              <button
                className="btn btnHeight me-2 px-4"
                style={{
                  background: active == "all" ? "#556ee6" : "#f4f4f4",
                  color: active == "all" ? "#FFF" : "#495057"
                }}
                onClick={() => {
                  setActive("all");
                }}
              >
                All
                            </button>
              <button
                className="btn btnHeight me-2 px-4"
                style={{
                  background: active == "active" ? "#556ee6" : "#f4f4f4",
                  color: active == "active" ? "#FFF" : "#495057"
                }}
                onClick={() => {
                  setActive("active");
                }}
              >
                Active
                            </button>
              <button
                className="btn btnHeight me-2 px-4"
                style={{
                  background: active == "deactive" ? "#556ee6" : "#f4f4f4",
                  color: active == "deactive" ? "#FFF" : "#495057"
                }}
                onClick={() => {
                  setActive("deactive");
                }}
              >
                Deactive
                            </button>
            </Col>
            <Col md={6} sm={4} className="mb-3 d-flex flex-row-reverse">

              <button className="btn btnUpload btnHeight px-4" style={{ margin: "0" }} onClick={() => {
                setFilterModal(true)
              }}> <img src={FilterIcon} style={{ marginRight: "5px" }} />Filter</button>
            </Col>
          </Row>
          <div>
            <Card className="w-100 mt-4">
              <CardBody>
                <div className='py-3'>
                  <div>
                    <div className="table-responsive">
                      <Table>
                        <thead>
                          <tr className='bgHeaderTable'>
                            {/* <th className='font-size-14'>#</th> */}
                            <th className='font-size-14'>I.D</th>
                            <th className='font-size-14'>Name</th>
                            <th className='font-size-14'>Email</th>
                            <th className='font-size-14'>Phone Number</th>
                            <th className='font-size-14'>Location of Resale </th>
                            <th className='font-size-14'>Status</th>
                            <th className='font-size-14'></th>
                          </tr>
                        </thead>
                        <tbody>

                          {list.map((item, index) => <CardItem
                            key={index}
                            index={index}
                            {...item}
                            item={item}
                            Service={SellerService}
                            setShouldGetData={setShouldGetData}
                          // updateHandler={() => updateHandler(item.id)}
                          />)}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
            <Row className="d-flex justify-content-end">
              <Col className="d-flex justify-content-between" md={12} sm={12}>
                <Paginator
                  service={sellerService}
                  pageOptions={pageOptions}
                  setData={(data) => setList([...data])}
                  setPageOptions={setPageOptions}
                  filtersParams={filtersParams}
                  shouldGetData={shouldGetData}
                  setShouldGetData={setShouldGetData}
                />
              </Col>
            </Row>
            <FilterModal
              filterModal={filterModal}
              setFilterModal={setFilterModal}
              updateFiltersData={setFilterData} />
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Seller;